import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Dra. Suni Wiphala - Médica Integral en Santiago de Chile</title>
        <meta name="description" content="Consulta de medicina integral con la Dra. Suni Wiphala. Especialista en control de climaterio, diabetes, hipertensión y salud comunitaria en Santiago. Agenda tu hora." />
      </Helmet>
      <Hero />
      <About />
      <Services />
      <Contact />
    </>
  );
};

export default HomePage;
